<template>
  <div id="app">
    <!-- <van-nav-bar
      v-if="!$route.meta.isOpen"
      :title="titles"
      fixed
      placeholder
      border
      safe-area-inset-top
      z-index="10000"
      :left-arrow="!$route.meta.hideBack"
      @click-left="$router.back()"
    /> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      titles: ''
    }
  },
  mounted () {
  },
  updated () {
    this.titles = this.$route.meta.title || '山西博物院'
  },
  methods: {}
}
</script>

<style lang="scss">
//#app {
//  font-family: Avenir, Helvetica, Arial, sans-serif;
//  -webkit-font-smoothing: antialiased;
//  -moz-osx-font-smoothing: grayscale;
//}

input:-internal-autofill-previewed,
input:-internal-autofill-selected {
  -webkit-text-fill-color: #000 !important;
  transition: background-color 5000s ease-in-out 0s !important;
}

/* .van-nav-bar {
  background-color: transparent !important;
} */
 html,
 body,
 #app {
   height: 100%;
 }
</style>
